import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const referralApi = createAsyncThunk("referral", async () => {
  const response = await axiosInstance.get("/referral");
  return response.data;
});

const referralSlice = createSlice({
  name: "referral",
  initialState: {
    referral: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(referralApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(referralApi.fulfilled, (state, action) => {
        state.referral = action.payload;
        state.loading = false;
      })
      .addCase(referralApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default referralSlice.reducer;
